import type { ReactNode } from "react";
import { List, Stack } from "@chakra-ui/react";

export const WhyChooseList = ({ children }: { children: ReactNode }) => (
  <List>
    <Stack
      direction={{ base: "row", md: "column" }}
      spacing={{ base: 4, md: 8 }}
      overflowX="scroll"
      mx={{ base: -4, md: 0 }}
      scrollSnapType="x mandatory"
      sx={{
        msOverflowStyle: "none",
        "&::-webkit-scrollbar": {
          display: "none",
        },
      }}
    >
      {children}
    </Stack>
  </List>
);
